import angular from 'angular';

import { endOfFilter, formatFilter, fromNowFilter } from './moment.filter.js';
import { momentProvider } from './moment.provider.ts';

export default angular
  .module('moment', [])
  .filter('fromNow', fromNowFilter)
  .filter('format', formatFilter)
  .filter('endOf', endOfFilter)
  .provider('moment', momentProvider);
